import { useState } from "react";
import { useConfigStore } from "../../stores/ConfigStore";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { createPortal } from "react-dom";
import { DndContext, DragOverlay } from "@dnd-kit/core";
import GrapeItem from "./GrapeItem";
import { Button, Stack } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { useLanguage } from "../../stores/LanguageStore";

const GrapeFields = ({ items, setItems }) => {
  const lang = useLanguage((s) => s.language);
  const datafields = useConfigStore((s) => s.datafields);
  const [activeDrag, setActiveDrag] = useState(null);

  function handleDragStart(event) {
    setActiveDrag(items.find((x) => x.id === event.active.id));
  }

  function handleDragEnd(event) {
    const { active, over } = event;

    if (over) {
      if (active.id !== over.id) {
        setItems((items) => {
          const oldIndex = items.findIndex((x) => x.id === active.id);
          const newIndex = items.findIndex((x) => x.id === over.id);

          return arrayMove(items, oldIndex, newIndex);
        });
      }
    }
    setActiveDrag(null);
  }

  const handleAdd = () => {
    let newItem = null;
    for (let i = 0; i < datafields.length; i++) {
      if (!items.find((x) => x.id === datafields[i].id)) {
        newItem = {
          ...datafields[i],
          label: datafields[i].name,
          placeholder: datafields[i].name,
        };
        break; // Exit the loop after adding the first unused element
      }
    }

    setItems((prev) => [...prev, newItem]);
  };

  return (
    <Stack>
      <Stack pos={"relative"}>
        <DndContext onDragEnd={handleDragEnd} onDragStart={handleDragStart}>
          <SortableContext items={items} strategy={verticalListSortingStrategy}>
            {items.map((item, i) => (
              <GrapeItem
                key={item.id}
                index={i}
                item={item}
                setItems={setItems}
                items={items}
              />
            ))}
          </SortableContext>
          {createPortal(
            <DragOverlay>
              {activeDrag ? (
                <GrapeItem item={activeDrag} items={items} />
              ) : null}
            </DragOverlay>,
            document.body
          )}
        </DndContext>
      </Stack>

      <Button
        onClick={handleAdd}
        variant="light"
        leftSection={<IconPlus size={18} />}
      >
        {lang.forms.add_field}
      </Button>
    </Stack>
  );
};

export default GrapeFields;
